import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f1d64530"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "icon icon-back"
}
const _hoisted_2 = { class: "d-profile__main" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = { class: "d-aside" }
const _hoisted_5 = { class: "d-aside__main-menu" }
const _hoisted_6 = { class: "right" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-close" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!
  const _component_ProfilePhoto = _resolveComponent("ProfilePhoto")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_app_beta_user_pop_up = _resolveComponent("app-beta-user-pop-up")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_desktop_header = _resolveComponent("desktop-header")!
  const _component_drive_aside_main_menu = _resolveComponent("drive-aside-main-menu")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createBlock(_Transition, {
        key: 0,
        name: "fade",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_container, {
            class: "container",
            direction: "vertical"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_app_header, { class: "header" }, {
                "top-right": _withCtx(() => [
                  (_ctx.backText === 'Cancel')
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveProfile && _ctx.saveProfile(...args)), ["prevent"])),
                        class: _normalizeClass(["link", { disabled: _ctx.formInvalid }])
                      }, _toDisplayString(_ctx.$localize('profile.edit.done.button')), 3))
                    : _createCommentVNode("", true)
                ]),
                "top-left": _withCtx(() => [
                  _createElementVNode("a", {
                    href: "javascript:void(0);",
                    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.backAction && _ctx.backAction(...args)), ["prevent"])),
                    class: "back-link"
                  }, [
                    (_ctx.backArrow)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_1))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.backText), 1)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_row, {
                gutter: 0,
                align: "middle"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { align: "middle" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ProfilePhoto, {
                        user: _ctx.isMyProfile ? _ctx.profileStore.profile : _ctx.profileStore.foreignProfile,
                        isMyProfile: _ctx.isMyProfile,
                        skeleton: !!_ctx.dataRequest
                      }, null, 8, ["user", "isMyProfile", "skeleton"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _withDirectives(_createVNode(_component_el_row, {
                gutter: 0,
                align: "middle"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { align: "middle" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_view, null, {
                        default: _withCtx(({ Component }) => [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 512), [
                [_vShow, !_ctx.dataRequest]
              ]),
              (_ctx.spacesStore.showBetaUserPopUp)
                ? (_openBlock(), _createBlock(_component_app_beta_user_pop_up, {
                    key: 0,
                    onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.spacesStore.showBetaUserPopUp = false))
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock(_Transition, {
        key: 1,
        name: "fade",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_container, {
            class: "d-profile",
            direction: "vertical"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_desktop_header),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("aside", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_drive_aside_main_menu)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("a", {
                    href: "javascript:void(0);",
                    onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.backAction && _ctx.backAction(...args)), ["prevent"])),
                    class: "close-link"
                  }, _hoisted_8),
                  _createVNode(_component_el_row, {
                    gutter: 0,
                    align: "middle",
                    class: "photo-section"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { align: "middle" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ProfilePhoto, {
                            user: _ctx.isMyProfile ? _ctx.profileStore.profile : _ctx.profileStore.foreignProfile,
                            isMyProfile: _ctx.isMyProfile,
                            skeleton: !!_ctx.dataRequest
                          }, null, 8, ["user", "isMyProfile", "skeleton"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _withDirectives(_createVNode(_component_el_row, {
                    gutter: 0,
                    align: "middle"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { align: "middle" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_router_view, null, {
                            default: _withCtx(({ Component }) => [
                              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 512), [
                    [_vShow, !_ctx.dataRequest]
                  ]),
                  (_ctx.spacesStore.showBetaUserPopUp)
                    ? (_openBlock(), _createBlock(_component_app_beta_user_pop_up, {
                        key: 0,
                        onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.spacesStore.showBetaUserPopUp = false))
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
}